import { useFadeIn } from './useFadeIn';

export default function CTAStrip() {
  const ref = useFadeIn();

  return (
    <section data-testid="cta-strip-section" className="cta-strip">
      <div className="cta-strip-bg">
        <svg width="700" height="700" viewBox="0 0 700 700" fill="none">
          <circle cx="350" cy="350" r="330" stroke="white" strokeWidth="1"/>
          <circle cx="350" cy="350" r="220" stroke="white" strokeWidth="1"/>
          <circle cx="350" cy="350" r="110" stroke="white" strokeWidth="1"/>
          <line x1="20" y1="350" x2="680" y2="350" stroke="white" strokeWidth="0.5"/>
          <line x1="350" y1="20" x2="350" y2="680" stroke="white" strokeWidth="0.5"/>
        </svg>
      </div>
      <div ref={ref} className="cta-strip-inner fade-up">
        <p className="cta-strip-overline">Ready to grow?</p>
        <h2 className="cta-strip-title">
          Let's build something<br /><em>that lasts.</em>
        </h2>
        <div className="cta-strip-btns">
          <a
            data-testid="cta-strip-button"
            href="#contact"
            className="btn-white"
          >
            Contact Us
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path d="M1 7h12M7 1l6 6-6 6" stroke="#000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </a>
          <a href="#services" className="btn-outline-white">View Services</a>
        </div>
      </div>
    </section>
  );
}
